import isInteger from 'lodash/isInteger';
import isNaN from 'lodash/isNaN';
import toNumber from 'lodash/toNumber';
import { EMPTY_DASH } from '../../constants';

const CURRENCY_MAPPING: Record<string, (value: number, noFraction?: boolean) => string> = {
    USD: (price, noFraction) =>
        price.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            ...(noFraction && { maximumFractionDigits: 0 }),
        }),
    EUR: (price, noFraction) =>
        price.toLocaleString('en-US', {
            style: 'currency',
            currency: 'EUR',
            ...(noFraction && { maximumFractionDigits: 0 }),
        }),
    RUB: (price, noFraction) =>
        price.toLocaleString('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            maximumFractionDigits: noFraction || isInteger(price) ? 0 : 2,
        }),
};

type Options<I = string> = {
    code?: string;
    invalidValue?: I;
    noFraction?: boolean;
};

/*
 * @deprecated использовать функцию {format} from @/share/lib/string
 */
export const formatPrice = <I = string>(price: number | string, options: Options<I> = {}): string | I => {
    const { code = 'RUB', invalidValue = EMPTY_DASH, noFraction = false } = options;
    const num = toNumber(price);

    if (isNaN(num)) {
        return invalidValue;
    }

    return CURRENCY_MAPPING[code]?.(num, noFraction) ?? invalidValue;
};
